<template>
  <div class="comp-field-filter">
    <jw-trigger ref="triggerRef" trigger="click" :click-to-close="false" @popup-visible-change="poupSwitch">
      <div class="cover hand" @click="() => (popupVisible = !popupVisible)"></div>
      <template #content>
        <div class="comp-tree-select" v-if="popupVisible">
          <div class="search-content">
            <div class="search-rang-wrap">
              <div :class="['rang-item', 'search-all-item', isSearchAllFields ? 'active' : '']" @click="handleSearch('all')">
                <span>搜索全部</span>
                <icon-check v-if="isSearchAllFields" class="item-check-icon" />
              </div>
              <div class="rang-item" @click="handleSearch('field')">
                <span>搜索特定字段</span>
                <span>
                  <icon-down v-if="!showSearchFields" />
                  <icon-up v-else />
                </span>
              </div>
            </div>
            <template v-if="showSearchFields">
              <div class="search-rang-list">
                <jw-input v-model="searchInput" :placeholder="$t('搜索字段名称')" size="small"> </jw-input>
                <template v-if="getSearchFields()">
                  <div class="rang-item search-rang-item" v-for="item in searchFields.filter((v) => v.label?.indexOf(searchInput) > -1)" :key="item.value" @click="handleSearchRang(item)">
                    <div class="rang-item-content">
                      <component :is="getFieldIcn(item)" />
                      <span class="rang-item-label" :title="item.label">{{ item.label }}</span>
                    </div>
                    <div class="rang-item-check-icon">
                      <icon-check v-if="selectValue.includes(item.value)" class="item-check-icon" />
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="no-data-svg">
                    <jw-empty :img-src="noDataSvg" :description="$t('暂无数据')"></jw-empty>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
      </template>
    </jw-trigger>
    <jw-input-group class="input-group-wrap">
      <jw-input ref="inputSearchRef" :style="{ borderRadius: '6px', width: '187px' }" v-qfeiTrim v-model="data.inputValue" :placeholder="`在数据中模糊搜索`" allow-clear @change="changeVal" @press-enter="handlePressEnter" :name="'conditionschildren'" size="small" :class="{ 'filter-search-active': data.inputValue }">
        <template #prefix>
          <div class="hand" @click="inputSearchBlur">
            <icon-search />
          </div>
        </template>

        <template #suffix>
          <icon-down class="down-icon" />
        </template>
      </jw-input>
    </jw-input-group>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, computed } from 'vue';
import useFields from '@/hooks/fields';
import { tools } from '@/utils/tools';
import noDataSvg from '@/assets/images/no-data-150.svg';
const emits = defineEmits(['cb']);
const props = defineProps({
  fieldColumns: {
    type: [Array],
    default: () => []
  },
  defaultValue: {
    type: [String],
    default: ''
  },
  entityId: {
    type: [String],
    default: ''
  }
});

const data = reactive({
  inputValue: props.defaultValue || ''
});
const triggerRef = ref();
const isSearchAllFields = computed(() => {
  return selectValue.value?.length === 0;
}); // 是否搜索所有字段
const showSearchFields = ref(false); // 是否展示具体字段
const inputSearchRef = ref();
const selectValue = ref([]);
const popupVisible = ref(false);
const searchInput = ref('');
// const isSubTable = ref(true);

const searchFields = ref([]); // 所有筛选字段
const excludeTypes = [8, 9, 10, 26];
const excludeFieldKeys = ['qccId', 'businessId'];
const fieldList = computed(() => {
  return props.fieldColumns;
});
const prevSelectValue = ref([]); // 上一次的搜索字段

// 比较两个数组是否包含相同的元素（不考虑顺序）
const areArraysEqual = (arr1, arr2) => {
  if (!arr1 || !arr2) return arr1 === arr2;
  if (arr1.length !== arr2.length) return false;
  return arr1.every((item) => arr2.includes(item)) && arr2.every((item) => arr1.includes(item));
};

const getSearchFields = () => {
  if (searchInput.value) {
    const _array = searchFields.value.filter((v) => v.label?.indexOf(searchInput.value) > -1);
    return _array?.length > 0;
  }
  return true;
};

onMounted(() => {
  if (fieldList.value?.length) {
    fieldList.value.forEach((item) => {
      if (item.fieldType === 27) {
        // 子表单
        item.fieldVos?.forEach((k) => {
          searchFields.value.push({
            label: `${item.fieldName}.${k.fieldName}`,
            value: `${item.fieldKey}.${k.fieldKey}`,
            fieldType: k.fieldType
          });
        });
      } else {
        searchFields.value.push({
          label: item.fieldName,
          value: item.fieldKey,
          fieldType: item.fieldType,
          fieldOldType: item.business?.fieldType
        });
      }
    });

    searchFields.value = searchFields.value.filter((fItem) => {
      if (excludeTypes.includes(fItem.fieldType)) {
        return false;
      }
      if (fItem.fieldType === 21) {
        if (excludeTypes.includes(fItem.fieldOldType)) {
          return false;
        }
      }
      if (excludeFieldKeys.includes(fItem.value)) {
        return false;
      }
      return true;
    });
    const localSearchFields = tools.getLocalStorage(`searchFields-${props.entityId}`);
    if (localSearchFields?.length) {
      selectValue.value = localSearchFields;
      isSearchAllFields.value = false;
      showSearchFields.value = true;
    }
  } else {
    selectValue.value = [];
  }

  prevSelectValue.value = [...selectValue.value]; // 上一次的搜索字段
});
const { fieldIconMapping } = useFields(); // 获取字段图标
const getFieldIcn = (field) => {
  return fieldIconMapping.value[Number(field.fieldType)];
};
// 点击搜索图标失去焦点
const inputSearchBlur = () => {
  inputSearchRef.value?.blur?.();
  changeVal(data.inputValue);
};

const poupSwitch = (e) => {
  if (e == false) {
    popupVisible.value = false;
    tools.setLocalStorage(`searchFields-${props.entityId}`, selectValue.value);
    if (!areArraysEqual(selectValue.value, prevSelectValue.value) && data.inputValue) {
      changeVal(data.inputValue);
    }
  }
};

const handlePressEnter = () => {
  changeVal(data.inputValue);
};

const changeVal = (v) => {
  const searchFields = selectValue.value.map((e) => {
    if (e?.split('.').length === 2) {
      // 子表单

      return {
        field: e?.split('.')[0],
        subField: e?.split('.')[1]
      };
    } else {
      // 主表单
      return {
        field: e
      };
    }
  });

  const params = {
    field: searchFields,
    value: v || data.inputValue
    // isGroup: false,
    // operation: 'like',
    // remark: Object.keys(subFormItem)?.length !== 0 ? JSON.stringify({ entity: subFormItem.entityId, fieldKey: subFormItem?.fieldKey, settingId: subFormItem.id }) : null,
  };

  emits('cb', { params: v ? params : undefined });
  console.log(48, params);
};

const handleSearch = (type) => {
  if (type === 'all') {
    isSearchAllFields.value = true;
    tools.removeLocalStorage(`searchFields-${props.entityId}`);
    selectValue.value = [];
    // triggerRef.value?.close(false);
  } else {
    showSearchFields.value = !showSearchFields.value;
  }
};

// 点击搜索特定字段
const handleSearchRang = (item) => {
  isSearchAllFields.value = false;
  if (selectValue.value.includes(item.value)) {
    selectValue.value = selectValue.value.filter((e) => e !== item.value);
  } else {
    selectValue.value = [...selectValue.value, item.value];
  }
};
</script>
<style scoped lang="less">
@import './field-filter.less';
</style>
<style lang="less">
.tree-select-condition {
  .arco-tree-node-title {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
</style>
